import styled from 'styled-components';

export const Container = styled.div`
	max-width: 800px;
	margin: 0 auto;
	padding: 40px 20px;
	width: 100%;
`;

export const Header = styled.div`
	margin-bottom: 32px;
`;

export const BackButton = styled.button`
	background: none;
	border: none;
	color: ${({ theme }) => theme.colors.punchupOrange || '#fe5e25'};
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	padding: 8px 0;
	margin-bottom: 16px;
	display: flex;
	align-items: center;
	gap: 8px;
	transition: opacity 0.2s;

	&:hover {
		opacity: 0.8;
	}
`;

export const Title = styled.h1`
	font-size: 32px;
	font-weight: 700;
	color: #222;
	margin: 0;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		font-size: 24px;
	}
`;

export const SearchContainer = styled.div`
	position: relative;
	margin-bottom: 24px;
`;

export const SearchInput = styled.input`
	width: 100%;
	padding: 14px 16px 14px 48px;
	border-radius: 12px;
	border: 1.5px solid #e5e5e5;
	background-color: #fff;
	color: #222;
	font-size: 16px;
	transition: border-color 0.2s, box-shadow 0.2s;
	box-sizing: border-box;

	&::placeholder {
		color: #888;
	}

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.colors.punchupOrange || '#fe5e25'};
		box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.punchupOrange || '#fe5e25'}20;
	}
`;

export const SearchIcon = styled.div`
	position: absolute;
	left: 16px;
	top: 50%;
	transform: translateY(-50%);
	color: #888;
	pointer-events: none;
	display: flex;
	align-items: center;
`;

export const TagsList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-bottom: 24px;
`;

export const TagItem = styled.div<{ $selected?: boolean }>`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 16px;
	border-radius: 12px;
	background-color: ${({ $selected }) => ($selected ? '#f0f0f0' : '#fff')};
	border: 2px solid ${({ $selected, theme }) => ($selected ? theme.colors.punchupOrange || '#fe5e25' : '#e5e5e5')};
	cursor: pointer;
	transition: all 0.2s;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

	&:hover {
		background-color: #f8f8f8;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
		transform: translateY(-2px);
	}
`;

export const TagInfo = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const TagName = styled.span`
	font-size: 16px;
	font-weight: 600;
	color: #222;
`;

export const TagDescription = styled.span`
	font-size: 14px;
	color: #888;
`;

export const TagColorPreview = styled.div<{ $color?: string }>`
	width: 32px;
	height: 32px;
	border-radius: 50%;
	background-color: ${({ $color }) => $color || '#F5F5F5'};
	flex-shrink: 0;
	border: 2px solid #e5e5e5;
`;

export const CreateNewButton = styled.button`
	width: 100%;
	padding: 14px 16px;
	border-radius: 12px;
	border: 2px dashed #888;
	background-color: #fff;
	color: #222;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s;

	&:hover {
		background-color: #f5f5f5;
		border-color: ${({ theme }) => theme.colors.punchupOrange || '#fe5e25'};
		border-style: solid;
	}
`;

export const EmptyState = styled.div`
	text-align: center;
	padding: 60px 20px;
	color: #888;
	font-size: 16px;
	margin-bottom: 24px;
`;

export const CreateFormContainer = styled.div`
	background-color: #f8f8f8;
	border: 2px solid ${({ theme }) => theme.colors.punchupOrange || '#fe5e25'};
	border-radius: 12px;
	padding: 24px;
	margin-top: 24px;
	display: flex;
	flex-direction: column;
	gap: 20px;
	animation: slideDown 0.3s ease-out;

	@keyframes slideDown {
		from {
			opacity: 0;
			transform: translateY(-10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

export const FormField = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const Label = styled.label`
	font-size: 14px;
	font-weight: 600;
	color: #222;
`;

export const Input = styled.input`
	padding: 12px 16px;
	border-radius: 8px;
	border: 1.5px solid #e5e5e5;
	background-color: #fff;
	color: #222;
	font-size: 14px;
	transition: border-color 0.2s, box-shadow 0.2s;
	font-family: inherit;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.colors.punchupOrange || '#fe5e25'};
		box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.punchupOrange || '#fe5e25'}20;
	}

	&::placeholder {
		color: #888;
	}
`;

export const TextArea = styled.textarea`
	padding: 12px 16px;
	border-radius: 8px;
	border: 1.5px solid #e5e5e5;
	background-color: #fff;
	color: #222;
	font-size: 14px;
	min-height: 80px;
	resize: vertical;
	transition: border-color 0.2s, box-shadow 0.2s;
	font-family: inherit;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.colors.punchupOrange || '#fe5e25'};
		box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.punchupOrange || '#fe5e25'}20;
	}

	&::placeholder {
		color: #888;
	}
`;

export const ColorPickerWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const ColorInput = styled.input`
	width: 60px;
	height: 40px;
	border: 1.5px solid #e5e5e5;
	border-radius: 8px;
	cursor: pointer;
	background-color: transparent;

	&::-webkit-color-swatch-wrapper {
		padding: 2px;
	}

	&::-webkit-color-swatch {
		border: none;
		border-radius: 6px;
	}
`;

export const ColorPreview = styled.div<{ $color?: string }>`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	background-color: ${({ $color }) => $color || '#F5F5F5'};
	border: 2px solid #e5e5e5;
	flex-shrink: 0;
`;

export const FormActions = styled.div`
	display: flex;
	gap: 12px;
	justify-content: flex-end;
	margin-top: 8px;
`;
